'use strict';

var React = require('react');

var SvgArchiveMajor = function SvgArchiveMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1a1.5 1.5 0 0 0-1.5 1.5v1.5h18v-1.5a1.5 1.5 0 0 0-1.5-1.5h-15zm-.5 16.5a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-11.5h-16v11.5zm5-8.5h6v2h-6v-2z"
  }));
};

exports.SvgArchiveMajor = SvgArchiveMajor;
